document.addEventListener("DOMContentLoaded", () => {
    class ParallaxSection {
        constructor(container) {
            this.container = container;
            this.images = container.querySelectorAll('.parallax-image');
            this.startScroll = null;
            this.isWithinBlock = false;
            this.storageKey = `scrolledDistance_${this.container.dataset.sectionId}`;
            this.scrolledDistance = 0;

            const storedDistance = localStorage.getItem(this.storageKey);
            if (storedDistance && !isNaN(storedDistance)) {
                this.scrolledDistance = this.isElementInViewport(this.container) ? parseInt(storedDistance, 10) : 0;
                this.scrollX(this.scrolledDistance);
            }

            document.addEventListener('scroll', () => this.onScroll());
        }

        onScroll() {
            if (this.isElementInViewport(this.container)) {
                const blockTop = this.container.getBoundingClientRect().top;
                const blockBottom = this.container.getBoundingClientRect().bottom;
                const windowHeight = window.innerHeight;

                if (blockTop >= 0 && blockBottom > windowHeight) {
                    if (!this.isWithinBlock) {
                        this.startScroll = window.scrollY - this.scrolledDistance;
                        this.isWithinBlock = true;
                    }
                    this.scrolledDistance = window.scrollY - this.startScroll;
                }

                this.scrollX(this.scrolledDistance);
            }
        }

        scrollX(scrolledDistance) {
            if (scrolledDistance >= 0) {
                localStorage.setItem(this.storageKey, scrolledDistance);

                this.images.forEach((image, index) => {
                    const speed = (index + 1) * 0.3; // Adjust speed for each image
                    const scrollingPosition = scrolledDistance * speed;
                    if (index !== 0) {
                        image.style.transform = `translateX(${scrollingPosition}px)`;
                    }
                });
            }
        }

        isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            return rect.top <= (window.innerHeight - (window.innerHeight * 25 / 100));
        }
    }

    const parallaxContainers = document.querySelectorAll('.parallax-container');
    parallaxContainers.forEach(container => {
        new ParallaxSection(container);
    });
});